import React, { ReactElement } from 'react';

import Box from '../../../components/Box/Box';

type TBadge = {
  kind: string;
  className?: string;
  children?: ReactElement | number;
};

const Badge = (props: TBadge) => {
  const { kind, className, children } = props;

  return (
    <Box as="i" parent="Header" name="badge" modifiers={kind} className={className}>
      {children}
    </Box>
  );
};

export default Badge;
